import { render, staticRenderFns } from "./BnCustomHelp.vue?vue&type=template&id=7631c38e&scoped=true&"
import script from "./BnCustomHelp.vue?vue&type=script&lang=js&"
export * from "./BnCustomHelp.vue?vue&type=script&lang=js&"
import style0 from "./BnCustomHelp.vue?vue&type=style&index=0&id=7631c38e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7631c38e",
  null
  
)

export default component.exports